enum FileTypes {
  Video = 1,
  Image = 2,
}

export default FileTypes;
